import { render, staticRenderFns } from "./menu-block-accordions.vue?vue&type=template&id=5d127518&scoped=true&"
import script from "./menu-block-accordions.vue?vue&type=script&lang=js&"
export * from "./menu-block-accordions.vue?vue&type=script&lang=js&"
import style0 from "./menu-block-accordions.vue?vue&type=style&index=0&id=5d127518&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d127518",
  null
  
)

export default component.exports